import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../_services/auth.service';
import {CommunitiesService} from "../_services/communities.service";

export const roleGuard: CanActivateFn = (route, state) => {
    const router: Router = inject(Router);
    const authService: AuthService = inject(AuthService);
    const communitiesService: CommunitiesService = inject(CommunitiesService);

    if (authService.isSuperUser() || communitiesService.userHasCommunityRole(route.data['communityRoles'])) {
        return true;
    }
    router.navigate(['/404']);
    return false;
};
